import React from 'react';
import { useSelector } from 'react-redux';
import FullWidthContainer from '@starbucks-web/pattern-library/lib/components/full-width-container';

import { configSelector } from 'shared/app/shell';
import H1 from 'shared/app/components/h1';
import AuxiliaryProductInfo from './auxiliary-product-info';
import ColumnsTemplate from '../columns-template';
import ProductImage from './product-image';
import { usePdpContext } from '../pdp-provider';

import styles from './styles.cssm';

export const LeftColumn = () => <ProductImage />;

const RightColumn = ({ product }) => {
  const pdpMatchTitleAndCaloriesFont =
    useSelector(configSelector)?.pdpMatchTitleAndCaloriesFont;
  const productNameClass = pdpMatchTitleAndCaloriesFont
    ? styles.productNameSmall
    : styles.productName;
  return (
    <React.Fragment>
      <H1
        className={`text-bold color-textWhite ${productNameClass}`}
        data-e2e="product-name"
      >
        {product?.name || ''}
      </H1>
      <AuxiliaryProductInfo />
    </React.Fragment>
  );
};

const ProductDetailsHeader = () => {
  const product = usePdpContext().product;
  return (
    <FullWidthContainer className={`${styles.headerContainer}`}>
      <ColumnsTemplate
        className="items-center"
        leftColumn={<LeftColumn />}
        leftColumnClassName="py3"
        rightColumn={<RightColumn product={product} />}
        rightColumnClassName="pb5 lg-pb0 text-center lg-text-left"
      />
    </FullWidthContainer>
  );
};

export default ProductDetailsHeader;
